export const ONBOARDING_STEPS = [
  {
    id: 'organization',
    step: 1,
    title: 'Organization & specialty',
    description: 'Name your organization and choose at least one specialty.',
    optional: false,
  },
  {
    id: 'location',
    step: 2,
    title: 'Primary location',
    description: 'Add a practice or billing location (optional).',
    optional: true,
  },
  {
    id: 'data_upload',
    step: 3,
    title: 'RCM data upload',
    description: 'Upload 837/835 files for operational and analytics pipelines.',
    optional: true,
  },
  {
    id: 'integrations',
    step: 4,
    title: 'EHR & clearinghouse',
    description: 'Choose your EHR and clearinghouse connections.',
    optional: false,
  },
  {
    id: 'scenario',
    step: 5,
    title: 'Guided demo scenario',
    description: 'Load synthetic demo data for ERA analytics and Work Queue.',
    optional: false,
  },
  {
    id: 'complete',
    step: 6,
    title: 'Finish setup',
    description: 'Review highlights and mark onboarding complete.',
    optional: false,
  },
];

export const STEP_COUNT = ONBOARDING_STEPS.length;

function storageKey(orgId) {
  return `rcm_onboarding_manual_runs_${orgId || 'unknown'}`;
}

export function readStepRuns(orgId) {
  if (!orgId || typeof window === 'undefined') return {};
  try {
    return JSON.parse(localStorage.getItem(storageKey(orgId)) || '{}');
  } catch {
    return {};
  }
}

export function markStepRun(orgId, stepId) {
  if (!orgId || typeof window === 'undefined') return;
  const runs = readStepRuns(orgId);
  runs[stepId] = {
    at: new Date().toISOString(),
    count: (runs[stepId]?.count || 0) + 1,
  };
  localStorage.setItem(storageKey(orgId), JSON.stringify(runs));
}

export function stepIdFromNumber(stepNumber) {
  return ONBOARDING_STEPS.find((s) => s.step === stepNumber)?.id || 'organization';
}

export function stepNumberFromId(stepId) {
  return ONBOARDING_STEPS.find((s) => s.id === stepId)?.step || 1;
}

export function stepFromStatus(status) {
  if (!status) return 1;
  if (status.onboarding_completed) return 6;
  if (status.needs_organization_setup || status.needs_specialty) return 1;
  if (status.needs_integrations || status.current_step === 'integrations') return 4;
  if (status.needs_scenario_seed || status.current_step === 'seed') return 5;
  if (status.scenario_loaded && status.current_step === 'complete') return 6;
  return 1;
}

export function deriveStepComplete(stepId, status, manifest, runs = {}) {
  const checklist = manifest?.checklist || [];
  switch (stepId) {
    case 'organization':
      return Boolean(status && !status.needs_organization_setup && !status.needs_specialty);
    case 'location':
      return Boolean(runs?.location?.at);
    case 'data_upload':
      return (
        checklist.some((item) => item.item_key === 'upload_rcm_data' && item.completed)
        || Boolean(runs?.data_upload?.at)
      );
    case 'integrations':
      return Boolean(status && !status.needs_integrations);
    case 'scenario':
      return Boolean(status?.scenario_loaded);
    case 'complete':
      return Boolean(status?.onboarding_completed);
    default:
      return false;
  }
}

export function firstIncompleteStep(status, manifest, runs) {
  const incomplete = ONBOARDING_STEPS.find(
    (step) => !step.optional && !deriveStepComplete(step.id, status, manifest, runs)
  );
  return incomplete?.step || 1;
}
